import 'normalize.css';
import './assets/scss/style.scss';

import './assets/js/base.js';
import './assets/js/fadein-animation.js';
